import {MAX_UPLOAD_BYTES, MIME_TYPES} from '@common/constants/files';

export const ACCEPTED_FILE_TYPES = [
  MIME_TYPES.XLSX,
  MIME_TYPES.XLS,
  MIME_TYPES.CSV,
  '.xlsx',
  '.xls',
  '.csv',
];

export const ACCEPTED_FILE_EXTENSIONS = ['.xlsx', '.xls', '.csv'];

export const MAX_FILE_SIZE = MAX_UPLOAD_BYTES;

export const MAX_FILES_PER_UPLOAD = 10;
